<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div style="margin-right: 20px; margin-right: 20px">
                <span class="sa-flexbox-body-title">Documenti</span>
                <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickNuovoDocumento" class="mb-2">
                    <font-awesome-icon icon="plus"> </font-awesome-icon>
                    Aggiungi
                </b-button>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <div class="d-flex flex-column">
                        <b-alert v-if="tipo === 'A'" show variant="danger">ARCHIVIO</b-alert>
                        <b-row class="sa-label-info">
                            <b-col xs="3" sm="3" md="3" lg="3" xl="3">
                                <p>Record Totali: {{ rows }}</p>
                            </b-col>
                            <b-col xs="9" sm="9" md="9" lg="9" xl="9">
                                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                            </b-col>
                        </b-row>
                    </div>

                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="filterItems" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light">
                        <template #cell(index)="row">
                            {{ row.index + 1 + (currentPage - 1) * perPage }}
                        </template>
                        <template v-slot:cell(dataOra)="{ item }">
                            <span class="sa-data">{{ formatDateTime(item.dataOra) }}</span>
                        </template>
                        <template v-slot:cell(statoAttualeDataOra)="{ item }">
                            <span class="sa-data">{{ formatDateTime(item.statoAttualeDataOra) }}</span>
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <b-button v-if="item.statoAttuale === 'COMPLETA' && trasformare !== null && trasformare !== ''" size="sm" variant="outline-info" v-b-tooltip.hover title="Trasforma" @click="onClickTraforma(item)">
                                <i class="bi bi-recycle"></i>
                            </b-button>
                            <b-button v-if="item.statoAttuale === 'BOZZA'" size="sm" variant="outline-success" v-b-tooltip.hover title="Modifica Documento" @click="onClickEdit(item)">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <b-button size="sm" v-b-tooltip.hover title="Visualizza Documento" variant="outline-secondary no-text" @click="onClickView(item)" class="mr-1 no-text">
                                <font-awesome-icon icon="eye" />
                            </b-button>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <papercleand-documenti-edit-modal-component ref="PapercleandDocumentiEditModalComponent" @afterSaveSuccess="onAfterSaveSuccess" @beforLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></papercleand-documenti-edit-modal-component>
        <papercleand-documenti-view-modal-component ref="PapercleandDocumentiViewModalComponent" @beforLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></papercleand-documenti-view-modal-component>
    </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import axios from "axios";
import PapercleandDocumentiEditModalComponent from "./PapercleandDocumentiEditModalComponent.vue";
import PapercleandDocumentiViewModalComponent from "./PapercleandDocumentiViewModalComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { PapercleandDocumentiEditModalComponent, PapercleandDocumentiViewModalComponent },
    /* computed: {
        rows() {
            return this.items.length;
        },
    }, */
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/documenti",
            linkedit: "/editnumeratori",
            showModalLoading: false,
            items: [],
            filterItems: [],
            filtro: {},
            codiceTipo: null,
            nuovoTipo: null,
            tipo: "",
            trasformare: null,
            pathResourceTipiAnagrafica: "/dizionariotipi",
            nomeDocumento: "",
            tipoAnagraficaOptions: [{ codiceTipo: "", descrizioneTipo: "-Seleziona Valore-" }],
            jsonDataNuovoContatore: {},
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Numero",
                    key: "numero",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Intestatario",
                    key: "descrizioneAnagrafica",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Data Ora",
                    key: "dataOra",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
                //{
                //  label: "Stato Attuale",
                //key: "statoAttuale",
                // thStyle: "width: 5rem",
                // sortable: true,
                //},
                //{
                //  label: "Stato Attuale DataOra",
                //key: "statoAttualeDataOra",
                // thStyle: "width: 5rem",
                //  sortable: true,
                //},
                { class: "sa-table-column-action-double", key: "actions", label: "", thStyle: "width: 5rem" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    mounted() {
        let me = this;
        me.loadTipiAnagrafica();
    },
    methods: {
        loadData(filtro = {}, tipoAnagrafica = []) {
            let me = this;
            me.codiceTipo = this.$route.query.codiceTipo;
            filtro.page = me.currentPage;
            filtro.forPage = me.perPage;
            filtro.tipo = me.codiceTipo;
            // console.log(tipoAnagrafica);

            me.tipoAnagraficaOptions = tipoAnagrafica;
            me.filterItems = [];
            me.$emit("beforLoadData");
            let path = "";
            me.tipo = this.$route.query.tipo;
            let tipo = this.$route.query.tipo;
            if (tipo === "P") {
                path = me.pathResource;
            } else {
                path = me.pathResource + "/a";
            }
            // console.log("PREFOR");
            // console.log(me.codiceTipo);
            // console.log(me.tipoAnagraficaOptions);

            tipoAnagrafica.forEach((element) => {
                if (element.codiceTipo === me.codiceTipo) {
                    // console.log("TROVATO");
                    // console.log(element);

                    me.nomeDocumento = element.descrizioneTipo;
                    me.tipo = element.tipo;
                    me.trasformare = element.richiedeFattura;
                }
            });
            if (me.trasformare !== null) {
                tipoAnagrafica.forEach((element) => {
                    if (element.codiceTipo === me.trasformare) {
                        // console.log("TROVATO");
                        // console.log(element);

                        me.nomeDocumento = element.descrizioneTipo;
                        me.nuovoTipo = element.tipo;
                        // me.trasformare = element.richiedeFattura;
                    }
                });
            }
            // console.log(me.trasformare);

            UtilityMixin.methods.loadDataResources(path, filtro, me.loadDataSuccess, me.loadDataError);
            me.$emit("afterLoadData");
        },
        loadTipiAnagrafica() {
            let me = this;
            let filtro = {};
            filtro.sezioneDizionario = "DOCUMENTO";
            UtilityMixin.methods.loadDataResources(me.pathResourceTipiAnagrafica, filtro, me.loadTipiAnagraficaSuccess, me.loadTipiAnagraficaError);
        },
        loadTipiAnagraficaSuccess(response) {
            let me = this;
            me.tipoAnagraficaOptions = response.data.data.list;
            me.tipoAnagraficaOptions.unshift({ codiceTipo: "", descrizioneTipo: "-Seleziona Valore-" });
            me.loadData();
        },
        loadTipiAnagraficaError(response) {
            console.log(response);
        },

        onDeleteRiga(row) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + row.id;
            me.$emit("beforLoadData");
            axios
                .delete(link)
                .then((response) => {
                    this.$bvModal.msgBoxOk(response.data.messaggio, {
                        title: "",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    });
                    me.loadData(me.filtro);
                })
                .catch((e) => {
                    this.$bvModal.msgBoxOk(e.response.data.messaggio, {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    });
                });
            me.$emit("afterLoadData");
        },
        onAfterLoadData() {
            let me = this;
            me.$emit("afterLoadData");
        },
        onBeforeLoadData() {
            let me = this;
            me.$emit("beforLoadData");
        },
        loadDataSuccess(response) {
            let me = this;
            me.filterItems = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(response) {
            console.log(response);
        },

        onClickView(item) {
            let me = this;
            me.$emit("beforLoadData");
            me.$refs.PapercleandDocumentiViewModalComponent.openModal(item, me.nomeDocumento);
            me.$emit("afterLoadData");
        },
        onClickNuovoDocumento() {
            let me = this;
            me.$emit("beforLoadData");
            me.$refs.PapercleandDocumentiEditModalComponent.openModal(null, me.nomeDocumento);
            me.$emit("afterLoadData");
        },
        onClickEdit(item) {
            let me = this;
            me.$emit("beforLoadData");
            me.$refs.PapercleandDocumentiEditModalComponent.openModal(item, me.nomeDocumento);
            me.$emit("afterLoadData");
        },
        onClickTraforma(item) {
            let me = this;
            // console.log();

            // me.$router.push("/papercleandocumentotipi/documenti/trasforma/edit/-1?idDocumento=" + item.id + "&codiceTipo=" + me.codiceTipo + "&tipo=" + me.tipo);
            me.$router.push("/papercleandocumentotipi/documenti/trasforma/edit/-1?idDocumento=" + item.id + "&codiceTipo=" + me.codiceTipo + "&tipo=" + me.tipo + "&nuovoTipo=" + me.nuovoTipo + "&trasformare=" + me.trasformare);
        },
        onRefresh() {
            this.loadData(this.filtro);
        },
        onAfterSaveSuccess() {
            let me = this;
            me.$emit("beforLoadData");
            me.loadData(me.filtro);
        },
    },
};
</script>
